var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiscoAiClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5021 32.8925L29.5578 26.9471L35.5021 21.0022L32.8928 18.3926L26.948 24.3373L21.0033 18.3926L18.3937 21.0022L24.3387 26.9471L18.3926 32.8925L21.0019 35.5019L26.948 29.5562L32.8928 35.5019L35.5021 32.8925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoAiClose);
export default __webpack_public_path__ + "static/media/cisco-ai-close.a969d8a939db020a302e5fd0e337c373.svg";
export { ForwardRef as ReactComponent };